import { styled } from '@mui/material';

import { DESKTOP_MIN_WIDTH, TABLET_MIN_WIDTH } from '~/constants/common';
import { COLORS } from '~/styles/colors';

interface IconWrapperProps {
  $backgroundColor: string;
}

export const StyledContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '92px 75px 96px',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    padding: '10px',
    paddingBlock: 60,
  },
}));

export const StyledTitle = styled('div')(() => ({
  paddingTop: '20px',
  paddingBottom: '4px',
}));

export const StyledCardsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '16px',
  paddingTop: '67px',
  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    flexDirection: 'column',
  },
}));

export const StyledCard = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: '13px',
  padding: '24px 21px 24px 24px',
  backgroundColor: COLORS.white,
  borderRadius: '20px',
  maxWidth: 'calc(33% - 12px)',
  boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.05)',

  '&:hover': {
    boxShadow: `0 0 0 2px ${COLORS.primary}`,
    transition: '0.2s',
    cursor: 'default',
  },

  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    maxWidth: 'calc(50% - 16px)',
  },
  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    maxWidth: '100%',
  },
}));

export const IconWrapper = styled('div')<IconWrapperProps>(({ $backgroundColor }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: $backgroundColor,
  borderRadius: '10px',
  padding: '10px',
  width: '52px',
}));
